const ProfilePage = () => {
  return <div className="container profile-page padding-top">Profile Page!</div>;
};

export default ProfilePage;
